export default __webpack_public_path__ + "static/media/Logo-Movie-Project.a0049cf8.jpg";